import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
  // Button,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  // UncontrolledTooltip
} from "reactstrap";

class SimpleFooter extends React.Component {
  render() {
    return (
      <>
        <footer className="footer" style={{position:'fixed', bottom:0, left:0, right:0}}>
          <Container>
            <Row className=" align-items-center justify-content-md-between">
              <Col md="6">
                <div className="copyright">
                  © {new Date().getFullYear()}{" "}
                  <Link to="/">
                    EaseMyTrade{" "}
                  </Link>
                   Pvt. Ltd. All rights reserved.
                </div>
              </Col>
              <Col md="6">
                <Nav className=" nav-footer justify-content-end">
                  
                  <NavItem>
                    <NavLink
                      href="/support"
                    >
                      Support
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
          </Container>
        </footer>
      </>
    );
  }
}

export default SimpleFooter;
